/* src/app/reports/rpt-dtx/rpt-dtx.component.css */
table {
  table-layout: fixed;
  width: 100%;
}
.mat-table-wrapper {
  overflow-x: auto;
}
.font9 {
  font-size: .5625rem;
}
.font10 {
  font-size: .625rem;
}
.font11 {
  font-size: .6875rem;
}
.font12 {
  font-size: .75rem;
}
.font13 {
  font-size: .8125rem;
}
.font14 {
  font-size: .875rem;
}
.font15 {
  font-size: .9375rem;
}
.rtalign {
  text-align: right;
}
.rtalign-hdr {
  display: flex;
  justify-content: flex-end;
}
.footer-totals-panel {
  display: flex;
  background-color: hsl(51, 40%, 70%);
  font-weight: bold;
}
.footer-col {
  flex: 1;
  padding: 0 1rem;
  display: flex;
  align-items: center;
}
.footer-col:first-child {
  justify-content: flex-start;
}
.footer-col:nth-child(2) {
  justify-content: center;
}
.footer-col:nth-child(3) {
  justify-content: center;
}
.footer-col:nth-child(4) {
  justify-content: center;
}
.footer-col:nth-child(5) {
  justify-content: center;
}
.footer-col:last-child {
  justify-content: flex-end;
}
.clm-row:hover,
.det-row:hover,
.pay-row:hover {
  cursor: pointer;
}
.det-header-row,
.pay-header-row {
  height: 1.5rem;
}
.clm-row,
.det-row,
.det-row-desc,
.pay-row {
  height: 1.5rem;
}
.clm-header-row {
  background-color: hsl(51, 40%, 54%);
}
.clm-odd-row {
  background-color: hsl(51, 30%, 85%);
  height: 1.5rem;
  cursor: pointer;
}
.clm-even-row {
  background-color: hsl(51, 30%, 90%);
  height: 1.5rem;
  cursor: pointer;
}
.clm-row-details:nth-child(odd) {
  background-color: hsl(51, 20%, 75%);
}
.clm-row-details:nth-child(even) {
  background-color: hsl(51, 30%, 95%);
}
.totals {
  background-color: hsl(51, 40%, 70%);
  font-weight: bold;
}
.det-header-row {
  background-color: hsl(207, 40%, 50%);
}
.det-row:nth-child(odd) {
  background-color: hsl(207, 50%, 85%);
}
.det-row:nth-child(even) {
  background-color: hsl(207, 30%, 90%);
}
.det-row-desc:nth-child(odd) {
  background-color: hsl(207, 50%, 85%);
}
.det-row-desc:nth-child(even) {
  background-color: hsl(207, 30%, 90%);
}
.pay-header-row {
  background-color: hsl(140, 25%, 50%);
}
.pay-row:nth-child(odd) {
  background-color: hsl(140, 15%, 85%);
}
.pay-row:nth-child(even) {
  background-color: hsl(140, 15%, 90%);
}
.link-button {
  background: none;
  border: none;
  padding: 0;
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
.link-button:hover {
  text-decoration: none;
}
.link-button:focus {
  outline: none;
}
.toolbar-sm {
  height: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: clamp(0.25rem, 2vw, 1.5rem);
}
/*# sourceMappingURL=rpt-dtx.component.css.map */
